{
  "general": {
    "title": "Сравнение опций",
    "intro": "Краткий обзор различий между учетной записью сообщества, подпиской и разовой покупкой.",
    "tableheader": "Подписка",
    "note1": "* Возможна групповая покупка и скидка в зависимости от объемов.",
    "note2": "** Поддерживаемые языки: датский, немецкий, английский, испанский, финский, французский, итальянский, норвежский, польский, португальский (бразильский), русский, шведский",
    "note3": "*** Требуется бесплатная учетная запись сообщества myboardmaker.com; предназначено только сведений о заданиях."
  },
  "columnHeadings": {
    "community": "СООБЩЕСТВО",
    "onetime": "РАЗОВАЯ ПОКУПКА*",
    "personal": "ПОДПИСКА ДЛЯ ЛИЧНОГО ИСПОЛЬЗОВАНИЯ",
    "professional": "ПОДПИСКА ДЛЯ СПЕЦИАЛИСТОВ",
    "organization": "ПОДПИСКА ДЛЯ ОРГАНИЗАЦИЙ*"
  },
  "mobileHeadings": {
    "community": "Сообщество",
    "onetime": "Разовая покупка*",
    "personal": "Подписка для личного использования",
    "professional": "Подписка для специалистов",
    "organization": "Подписка для организаций*"
  },
  "rowHeadings": {
    "editor": "Boardmaker 7 Editor",
    "activations": "Активация",
    "languages": "Языки**",
    "licensing": "Лицензия",
    "pcsSymbols": "Символы PCS",
    "templates": "Шаблоны",
    "studentCenter": "Boardmaker 7 Student Center",
    "playActivitiesInstructor": "Воспроизвести задания как преподаватель",
    "playActivitiesStudent": "Воспроизвести задания как учащийся",
    "myBoardmaker": "myBoardmaker",
    "instructorManagement": "Управление преподавателями",
    "studentManagement": "Управление учащимися",
    "assignStudentActivities": "Назначение заданий учащимся",
    "cloudStorage": "Облачное хранилище",
    "createAndJoin": "Создание групп и присоединение к ним",
    "accessCommunity": "Доступ к более 120 тыс. заданиям сообщества",
    "shareActivity": "Возможность делиться заданиями в сообществе",
    "curriculum": "Учебная программа и содержимое",
    "activitiesToGo": "Boardmaker Activities to Go",
    "instructionalSolutions": "Обучающие решения",
    "premiumActivities": "Премиальные задания",
    "coreFirstLearning": "Core First Learning"
  },
  "rowValues": {
    "byDevice": "2 устройства ",
    "unlimited": "Без ограничений",
    "byKey": "Лицензионный ключ",
    "symbols": "Более 80.000",
    "templates": "Более 600",
    "languages": "12",
    "login": "Вход",
    "yes": "Да",
    "yesNote": "Да***",
    "no": "Нет"
  }
}